import React, { useState, Fragment } from 'react';
import { string, number, func } from 'prop-types';
import { patchUser } from '../../utilities/userUtil/userUtil';

/**
 * SettingsForm has everything you need to update a user's bio or profile visibility.
 * @returns {React.component} A settings form to render.
 */
const SettingsForm = (props) => {
  const userId = props.userId;
  const [aboutMe, setAboutMe] = useState(props.aboutMe);
  const [profileVisibility, setProfileVisibility] = useState(props.profileVisibility);

  /**
   * Handles the form submission.
   * @param event - The form submission event.
   */
  const handleSubmit = async (event) => {
    event.preventDefault();
    const response = await patchUser(userId, { aboutMe, profileVisibility });
    props.updateProfileDisplay(response);
  };
  /**
   * Render the SettingsForm.
   */
  return (
    <Fragment>
      <form className="settings-form" onSubmit={handleSubmit}>
        <div className="settings-form__section">
          <div className="section-heading-container">
            <h2 className="section-heading">Profile Settings</h2>
          </div>
          <div className="settings-form__ui-section">
            <p className="gray">My profile content is</p>
            <label htmlFor="public">
              <input
                id="public"
                type="radio"
                value="PUBLIC"
                name="profileVisibility"
                checked={(profileVisibility === 'PUBLIC')}
                onChange={event => setProfileVisibility(event.target.value)}
              />
              Public
            </label>
            <label htmlFor="private">
              <input
                id="private"
                className="bump"
                type="radio"
                value="PRIVATE"
                name="profileVisibility"
                checked={(profileVisibility === 'PRIVATE')}
                onChange={event => setProfileVisibility(event.target.value)}
              />
              Private
            </label>
          </div>
          <div className="settings-form__ui-section">
            <label htmlFor="aboutMe">
              <p className="gray">About Me</p>
              <textarea
                id="aboutMe"
                name="aboutMe"
                value={aboutMe}
                onChange={event => setAboutMe(event.target.value)}
              />
            </label>
          </div>
          <input type="submit" value="Save Settings" className="button" />
        </div>
        <div className="settings-form__section">
          <div className="section-heading-container">
            <h2 className="section-heading">Account Information</h2>
          </div>
          <p>To change your email address, password, or other site registration options, please visit the <a href="https://manage.bostonglobe.com/cs/mc/Login.aspx">Member Center Profile Page</a>.</p>
        </div>
      </form>
    </Fragment>
  );
};

/**
 * Validation on passed-in props.
 * @type {Object}
 */
SettingsForm.propTypes = {
  userId: number,
  aboutMe: string,
  profileVisibility: string,
  updateProfileDisplay: func,
};

export default SettingsForm;



// WEBPACK FOOTER //
// ./src/components/SettingsForm/SettingsForm.js